import styled from 'styled-components/macro';

import Typography from 'components/Typography/Typography';

/** Table wrapper: overflow for body scroll; extra header padding for tooltip icon.
 * scrollbar-gutter: stable reserves space for scrollbar to prevent layout shift on focus/click. */
export const DealerTableWrapStyled = styled.div`
  flex: 1;
  min-height: 0;
  min-width: 0;
  width: 100%;
  overflow: auto;
  scrollbar-gutter: stable;

  & .MuiTableCell-root {
    padding-left: 6px;
    padding-right: 6px;
    padding-top: 2px;
    padding-bottom: 2px;
    font-size: ${({ theme }): string => theme.fontSize.sm};
    border-bottom: none;
  }
  & .MuiTableHead-root .MuiTableCell-root {
    font-weight: ${({ theme }): string => theme.fontWeight.semibold.toString()};
    color: ${({ theme }): string => theme.colors.primary.variant9};
    font-size: ${({ theme }): string => theme.fontSize.xs};
    cursor: pointer;
    user-select: none;
  }
  /* Extra right padding in header dealer cell so tooltip icon is never clipped */
  & .MuiTableHead-root .MuiTableCell-root:first-of-type {
    padding-right: 28px;
  }
`;

export const DealerTitleStyled = styled(Typography)`
  margin: 0 0 4px 0;
  font-weight: ${({ theme }): string => theme.fontWeight.medium.toString()};
  flex-shrink: 0;
`;

export const SortIconWrapStyled = styled.span`
  display: inline-flex;
  align-items: center;
  margin-left: 2px;
  vertical-align: middle;
`;
